module.exports = __webpack_public_path__ + "static/media/ico-user.19f3cb54.svg";